import { api } from 'utility';
import {
  getVoucherServiceUrl,
  getGuildServiceUrl,
  getUsageRestrictionsUrl,
  getDelegationConsumptionUrl,
  getVoucherStatusUrl,
} from 'URLs';

export function getVourchers(params) {
  return api.get(getVoucherServiceUrl(), { params }).then((res) => res.data);
}

export function getGuildsList(obj) {
  const params = { ...obj };
  return api.get(getGuildServiceUrl(), { params }).then((res) => res.data);
}

export function getUsageRestrictions(data, params) {
  return api.post(getUsageRestrictionsUrl(), data, { params }).then((res) => res.data);
}

export function getDelegationConsumption(data, params) {
  return api.post(getDelegationConsumptionUrl(), data, { params }).then((res) => res.data);
}

export function changeVoucherStatus(id, newStatus) {
  return api
    .put(getVoucherStatusUrl(id), null, { params: { active: newStatus } })
    .then((res) => res.data);
}

export default {
  getVourchers,
  changeVoucherStatus,
  getGuildsList,
  getUsageRestrictions,
  getDelegationConsumption,
};
